export { default } from "./ResultTable";
